import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiRequestsService } from './api-requests.service';

export const authsGuard: CanActivateFn = (route, state) => {
  let api = inject(ApiRequestsService);
  let router = inject(Router)
  if (api.getAPIToken()) {
    return true
  }
  router.navigate(['/login'])
  return false;
};
